import { TabsCardModel } from '../models/tabs/tabs-card.model';
import { TabsCardStylingModel } from '../models/tabs/tabs-card-styling.model';

export const /** @type {?} */ TabsCardTemplates = {
  defaultTemplate: {
    property: new TabsCardModel({
      display: true,
      disable: false,
      label: 'Card'
    }),
    style: new TabsCardStylingModel()
  }
}
